exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MobilePopupWrapper{position:sticky;inset-block-end:0!important;width:100%;background-color:#fff;border-radius:4px 4px 0 0;box-shadow:0 4px 16px 0 rgba(134,142,150,.24),0 0 4px 0 #868e96;z-index:99}", ""]);

// exports
